import LoadingSpinner from "./LoadingSpinner.component";

export default LoadingSpinner;
